import React from "react"
import CurrencyInput from "../CurrencyInput/CurrencyInput"
import PercentageInput from "../PercentageInput/PercentageInput"

class CancellationRule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			id: this.props.id || this.generateId(),
			amount: this.props.amount || '',
			days_charge: this.props.days_charge || '',
			custom_rule: this.props.custom_rule || '',
			numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
			percentage: this.props.percentage || '',
			time_value: this.props.time_value || '',
		};

		this.onChange = this.onChange.bind(this);
		this.onChangePercentage = this.onChangePercentage.bind(this);
		this.onChangeAmount = this.onChangeAmount.bind(this);
		this.onChangeDaysCharge = this.onChangeDaysCharge.bind(this);
		this.onChangeCustomRule = this.onChangeCustomRule.bind(this);
	}

  /*******************
  * Render functions *
  ********************/

	render() {
		return (
	    <div className="cancellation-rule" key={this.state.id}>

	      {this.renderRemove()}

	      <div className="row" style={{marginBottom: 10}}>
	      	<div className="col-sm-12">
			      <div className="form-inline form-sentence text-center">
			        {I18n.t('reservations_cancelled')} &nbsp;
			        {
			        	this.props.read_only
			        	?
			        	<span>{this.state.time_value} {I18n.t('days')}</span>
			        	:
				        <div className="input-group input-group-numeric maxlength2" style={{marginLeft: 'auto', marginRight: 'auto', position: 'relative', top: -2}}>
				          <input type="text" className="form-control" name={this.inputName('time_value')} onChange={this.onChange.bind(this, 'time_value')} value={this.state.time_value} data-model="CancellationRule" data-column="time_value" data-type="number" data-min-length="0" />
				          <div className="input-group-addon">{I18n.t('days')}</div>
				        </div>
			        }
			        <span> &nbsp;</span>
			        {I18n.t('or_less_before_check_in_date_will_incur_the_following_cost')}:
			      </div>
				  </div>
				</div>

	      <div className="row">
	      	<div className="col-sm-4">
	      		<div className="form-group text-center">
							<label>{I18n.t('percentage_of_lodging')} <span className="ss-help help" title={I18n.t('cancellation_rule_percentage_of_lodging_helper_text')}></span></label>
							{
								this.props.read_only
								?
								<div>{this.state.percentage ? (this.state.percentage * 100) + '%' : ''}</div>
								:
				         <PercentageInput className="form-control" name={this.inputName('percentage')} onChangeEventType={true} onChange={this.onChangePercentage} value={this.state.percentage} data-model="CancellationRule" data-column="percentage" data-type="percentage" data-min-length="0" />
							}
			      </div>
	      	</div>

	      	<div className="col-sm-4">
	      		<div className="form-group text-center">
			        <label>{I18n.t('fixed_amount')} <span className="ss-help help" title={I18n.t('cancellation_rule_fixed_amount_helper_text')}></span></label>
			        {
			        	this.props.read_only
			        	?
			        	<div>{this.state.amount ? '$' + (numeral(this.state.amount / 100).format(this.state.numberFormat)) : ''}</div>
			        	:
				        <CurrencyInput className="form-control" name={this.inputName('amount')} onChangeEventType={true} onChange={this.onChangeAmount} value={this.state.amount} data-model="CancellationRule" data-column="amount" data-type="currency" data-min-length="0" />
			        }
			      </div>
	      	</div>

	      	<div className="col-sm-4">
	      		<div className="form-group text-center">
							<label>{I18n.t('number_of_nights')} <span className="ss-help help" title={I18n.t('cancellation_rule_date_based_helper_text')}></span></label>
			        {
			        	this.props.read_only
			        	?
			        	<div>{this.state.days_charge}</div>
			        	:
			        	<div className="input-group input-group-numeric maxlength1">
			          	<input type="text" className="form-control" name={this.inputName('days_charge')} onChange={this.onChangeDaysCharge} value={this.state.days_charge} data-model="CancellationRule" data-column="days_charge" data-type="number" data-min-length="0" />
			          	<div className="input-group-addon">{I18n.t('nights')}</div>
			        	</div>
			        }
			      </div>
	      	</div>
	      </div>
				<div className="row">
					<div className="text-center" style={{fontStyle: 'italic', fontWeight: 'bold'}}>{I18n.t('or')}</div>
				</div>
				<br/>
				<div className="row">
					<div className="form-group text-center">
						<label>{I18n.t('custom_cancellation_rule')} <span className="ss-help help" title={I18n.t('cancellation_rule_custom_based_helper_text')}></span></label>
						<textarea name={this.inputName('custom_rule')} defaultValue={this.state.custom_rule} data-model="CancellationRule" rows="4" data-column="custom_rule" data-type="string" className="form-control" onChange={this.onChangeCustomRule}></textarea>
					</div>
				</div>

	    </div>
		);
	}

	renderRemove() {
		if (typeof this.props.onRemove == 'function' && !this.props.read_only) {
			return (
	      <div className="row">
	      	<div className="col-sm-12">
			      <div style={{position: 'relative', top: -10, right: -10}}>
			        <div className="pull-right">
			          <button type="button" className="btn btn-secondary" onClick={this.props.onRemove.bind(this, this.state.id)}>{I18n.t('remove')}</button>
			        </div>
			      </div>
			    </div>
			  </div>
			);
		}
	}

	/******************
	* Change Handlers *
	*******************/

  onChange(name, event) {
    if (event && event.target && event.target.name) {
      var state = this.state;
      state[name] = event.target.value;
      this.setState(state, () => {
      	if (typeof this.props.onChange == 'function') {
      		this.props.onChange(this.state);
      	}
      });
    }
  }

	onChangeCustomRule(event) {
		var state = this.state;

    if (state.custom_rule != event.target.value) {
      state.custom_rule = event.target.value;
      state.amount = '';
      state.percentage = ''
			state.days_charge = ''

      this.setState(state, () => {
      	if (typeof this.props.onChange == 'function') {
      		this.props.onChange(this.state);
      	}
      });
    }
	}

  onChangeAmount(event) {
    var state = this.state;

    if (state.amount != event.target.value) {
      state.amount = event.target.value;
      state.percentage = '';
      state.days_charge = ''
			state.custom_rule = ''

      this.setState(state, () => {
      	if (typeof this.props.onChange == 'function') {
      		this.props.onChange(this.state);
      	}
      });
    }
  }

  onChangeDaysCharge(event) {
    var state = this.state;

    if (state.days_charge != event.target.value) {
      state.days_charge = event.target.value;
      state.amount = '';
      state.percentage = ''
			state.custom_rule = ''

      this.setState(state, () => {
      	if (typeof this.props.onChange == 'function') {
      		this.props.onChange(this.state);
      	}
      });
    }
  }

  onChangePercentage(event) {
    var state = this.state;

    if (state.percentage != event.target.value) {
      state.percentage = event.target.value;
      state.amount = '';
      state.days_charge = ''
			state.custom_rule = ''

      this.setState(state, () => {
      	if (typeof this.props.onChange == 'function') {
      		this.props.onChange(this.state);
      	}
      });
    }
  }

	/*******************
	* Helper Functions *
	********************/

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return '-' + text;
  }

  /**
  * Generates input name
  * @param {string} name Name of the field. Should have parens (e.g. [amount])
  */
  inputName(name) {
    var inputName = 'cancellation_rule';

	  if (this.state.id) {
	    inputName = inputName + "[" + this.state.id + "]";
	  }

    inputName = inputName + "[" + name + "]";

    return inputName;
  }

}

export default CancellationRule
